import BeyondlySvg from './beyondly.svg';
import BiodefSvg from './biodef.svg';
import BrightNowSvg from './bright-now.svg';
import CrystallureSvg from './crystallure.svg';
import DermascalpSvg from './dermascalp.svg';
import DseSvg from './dse.svg';
import EarthLoveLifeSvg from './earth-love-life.svg';
import EminaSvg from './emina.svg';
import InstaperfectSvg from './instaperfect.svg';
import KahfSvg from './kahf.svg';
import LaboreSvg from './labore.svg';
import LightPlusSvg from './light-plus.svg';
import MakeOverSvg from './make-over.svg';
import OmgSvg from './omg.svg';
import PutriSvg from './putri.svg';
import TaviSvg from './tavi.svg';
import WardahSvg from './wardah.svg';
import WonderlySvg from './wonderly.svg';

export const brandLogoMap = {
  Beyondly: BeyondlySvg,
  Biodef: BiodefSvg,
  'Bright Now': BrightNowSvg,
  Crystallure: CrystallureSvg,
  'Dermascalp Expert': DermascalpSvg,
  DSE: DseSvg,
  'Earth Love Life': EarthLoveLifeSvg,
  Emina: EminaSvg,
  Instaperfect: InstaperfectSvg,
  Kahf: KahfSvg,
  Labore: LaboreSvg,
  Lightplus: LightPlusSvg,
  'Make Over': MakeOverSvg,
  OMG: OmgSvg,
  Putri: PutriSvg,
  Tavi: TaviSvg,
  Wardah: WardahSvg,
  'Wardah Hair': WardahSvg,
  Wonderly: WonderlySvg,
};
